import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { eventPlatformApi, type PlatformDashboard } from '../../api/eventplatform';

export function QueueMonitorPage() {
  const [dashboard, setDashboard] = useState<PlatformDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = () => void eventPlatformApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/events" className="text-sm text-blue-600 hover:underline">← Event Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Queue Monitor</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {dashboard && (
        <dl className="mt-6 grid gap-4 sm:grid-cols-2">
          <div className="rounded border p-4 dark:border-slate-700"><dt className="text-sm text-slate-500">Queue depth</dt><dd className="text-2xl font-semibold">{dashboard.queue_depth}</dd></div>
          <div className="rounded border p-4 dark:border-slate-700"><dt className="text-sm text-slate-500">Pending outbox</dt><dd className="text-2xl font-semibold">{dashboard.pending_outbox}</dd></div>
          <div className="rounded border p-4 dark:border-slate-700"><dt className="text-sm text-slate-500">Retries</dt><dd className="text-2xl font-semibold">{dashboard.retry_count}</dd></div>
          <div className="rounded border p-4 dark:border-slate-700"><dt className="text-sm text-slate-500">Publishers</dt><dd className="text-2xl font-semibold">{dashboard.publisher_count}</dd></div>
        </dl>
      )}
    </div>
  );
}
